/*
 *   File : edit-phone.js
 *   Author : https://evoqins.com
 *   Description : Edit phone modal component
 *   Integrations : react-toastify
 *   Version : 1.0.0
*/


import React, { memo } from "react";

//Assets
import CloseBtn from "../../Assets/Images/close-btn.svg";

function OnboardingVideoModal(props) {

    return (
        <div className="modal fade e-onboarding-video-modal"
            id="onboarding-video"
            data-bs-backdrop="static"
            tabIndex="-1"
            aria-labelledby="EditPhoneModal"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="pb-4 modal-content e-bg-lotion e-border-radius-24">
                    <div className="modal-header border-0 justify-content-end py-3 px-3 px-sm-4 ">

                        <img src={CloseBtn}
                            id='onboarding-video'
                            draggable={false}
                            className='cursor-pointer'
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            alt='close'
                            onClick={props.onClose}
                        />
                    </div>

                    {/* Body */}
                    <div className="modal-body pb-2 px-3 px-sm-4 pt-0 d-flex flex-column">
                        <div className="ratio ratio-16x9">
                            <iframe
                                width="100%"
                                height="100%"
                                src={props.videoUrl ? props.videoUrl : `https://www.youtube.com/embed/${props.data}?autoplay=0&rel=0`} 
                                title="YouTube video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default memo(OnboardingVideoModal);